exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container {\n  margin: 20px 10px 0 10px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n}\n\n.header-container clearable-textfield {\n  width: 100%;\n}\n\n", ""]);

// exports
